import createVueComponent from '../createVueComponent';

const StopCircle = createVueComponent('StopCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['rect', { width: '6', height: '6', x: '9', y: '9', key: '1wrtvo' }],
]);

export default StopCircle;
